import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_how_many_suggestions_feedback_received_facility_addressed_1'

export const dataPointDefinition = {
  retracedId: 'yes_how_many_suggestions_feedback_received_facility_addressed_1',
  name: "If yes, how many suggestions and feedback received by the facility addressed topics related to women's rights in the wor",
  description:
    'The intent of this follow up is to determine if female workers have access to and feel comfortable enough to submit suggestions and provide feedback on their rights in the work place. ',
  meta: {
    slcpMeta: {
      key: 'wi-work-3',
      number: 'WI-WORK-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-work-3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37030,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
